import React from 'react';
import { AppBar, Badge, Box, IconButton, Link, Stack, Toolbar, Typography, useMediaQuery } from '@mui/material';
import { Menu as MenuIcon } from '@mui/icons-material';
import { useTheme } from '@mui/material/styles';
import { Breadcrumbs } from '../breadcrumb';
import { SquareChip } from '../chip';
import PageHeaderDrawer from './PageHeaderDrawer';
import PageHeaderMenuBar from './PageHeaderMenuBar';
import usePageMenuDrawer from './usePageMenuDrawer';
// The design is derived from the mini variant drawer example of mui.com.
// See https://mui.com/components/drawers/#mini-variant-drawer
function PageFrame({ children, chipLabel, chipColor, menu, adminWebsiteURL, atcWebsiteURL, memberWebsiteURL, }) {
    const theme = useTheme();
    const { toggle } = usePageMenuDrawer();
    const isBigScreen = useMediaQuery(theme.breakpoints.up('sm'));
    return (React.createElement(Box, { sx: { display: 'flex' } },
        React.createElement(AppBar, { position: "fixed", color: "primary", sx: { zIndex: theme.zIndex.drawer + 1 }, elevation: 0 },
            React.createElement(Toolbar, { variant: "dense", disableGutters: true, sx: { px: 2.5 } },
                React.createElement(IconButton, { sx: { p: 0 }, edge: "start", "aria-label": "menu", onClick: toggle, color: "inherit" },
                    React.createElement(MenuIcon, { fontSize: "small" })),
                isBigScreen ? (React.createElement(Stack, { gap: 3, direction: "row", sx: { flex: 1, display: 'flex', alignItems: 'center' } },
                    React.createElement(Link, { href: "/", color: "inherit", underline: "none" }, chipLabel && chipColor ? (React.createElement(Badge, { badgeContent: React.createElement(SquareChip, { label: chipLabel, color: chipColor, variant: "filled", sx: {
                                position: 'relative',
                                top: -4,
                                right: 10,
                                height: 'auto',
                                zIndex: 0,
                                '.MuiChip-label': {
                                    fontSize: '0.6rem',
                                    lineHeight: '0.6rem',
                                    px: 3 / 5,
                                    py: 1 / 3,
                                },
                            } }) },
                        React.createElement(Typography, { variant: "h1", sx: { ml: 1.5, fontSize: '1.25rem', lineHeight: 1, zIndex: 2, letterSpacing: '0.15rem' } },
                            "polaris",
                            React.createElement("span", { style: { fontSize: '1rem', verticalAlign: 'text-top' } }, "*")))) : (React.createElement(Typography, { variant: "h1", sx: { ml: 1.5, fontSize: '1.25rem', lineHeight: 1, letterSpacing: '0.15rem' } },
                        "polaris",
                        React.createElement("span", { style: { fontSize: '1rem', verticalAlign: 'text-top' } }, "*")))),
                    React.createElement(Breadcrumbs, null))) : null,
                React.createElement(PageHeaderMenuBar, { adminWebsiteURL: adminWebsiteURL, atcWebsiteURL: atcWebsiteURL, memberWebsiteURL: memberWebsiteURL }))),
        React.createElement(PageHeaderDrawer, { menu: menu }),
        React.createElement(Box, { component: "main", sx: { p: 1 / 2, width: '100%' } },
            React.createElement(Toolbar, { variant: "dense" }),
            children)));
}
export default React.memo(PageFrame);
